<template>
	<div>
		<el-page-header @back="goBack" content="测评结果设置"></el-page-header>
		<div class="topic-outer">
			<div class="appraisal-center fonts">
				<div class="pub-line">
					<span>分类：</span>
					<span class="glay"
						>{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
					>
				</div>
				<div class="flex-box pub-line">
					<div class="fl1">
						<span>名称：</span>
						<span class="glay">{{ detalisObj.name }}</span>
					</div>
					<div class="fl1">
						<span> 标识：</span>
						<span class="glay">{{ detalisObj.examId }}</span>
					</div>
				</div>

				<div class="flex-box pub-line">
					<div class="fl1">
						<span>解析：</span>
						<span class="glay">{{ detalisObj.schemeName }}</span>
					</div>
					<div class="fl1">
						<span> 题目：</span>
						<span class="glay"
							>共 <i>{{ detalisObj.questions }}</i
							>题</span
						>
					</div>
				</div>

				<div style="margin-top: 30px">
					<el-button type="primary" plain @click="handelResultSet"
						>脸谱详情设置
					</el-button>
				</div>
			</div>
		</div>
		<div class="topic-outer">
			<div class="appraisal-center fonts marr">
				<div>
					<span>类型：</span>
					<span>
						<el-tag
							class="tag-marr"
							:key="index"
							:class="{ activeBg: dimensionInfoId == item.examDimensionId }"
							effect="plain"
							@click="activeEvent(item, 'wd')"
							v-for="(item, index) in dimensionList"
						>
							{{ item.name }}
						</el-tag>

						<!-- <el-tag
							class="tag-marr"
							effect="plain"
							@click="handleDimensionEdit('wd')"
						>
							<i class="el-icon-edit"> </i>
						</el-tag> -->
					</span>
				</div>
				<div class="marr">
					<span>维度：</span>
					<span>
						<el-tag
							effect="plain"
							class="tag-marr"
							:class="{ activeBg1: datumId == item.code }"
							@click="activeEvent(item, 'jz')"
							:key="index"
							v-for="(item, index) in datumList"
							type="danger"
						>
							{{ item.name }}
						</el-tag>

						<!-- <el-tag
							class="tag-marr"
							effect="plain"
							type="danger"
							@click="handleDimensionEdit('jz')"
							><i class="el-icon-edit"></i
						></el-tag> -->
					</span>
				</div>
				<div class="marr">
					<el-button @click="handleClick('add')" type="success" size="small"
						>添加结果 <i class="el-icon-plus"></i
					></el-button>
				</div>
				<div class="marr">
					<div class="public-table-data">
						<el-table
							ref="multipleTable"
							size="medium"
							:data="resulData"
							border
							style="width: 100%"
							row-key="menuId"
							v-loading="loading"
						>
							<el-table-column
								type="index"
								label="序号"
								width="60"
								align="center"
							>
							</el-table-column>
							<el-table-column
								prop="minScore"
								label="最小值"
								width="80"
								align="center"
							>
								<template slot-scope="scope">
									<div class="content_div">
										{{ dataHandling(scope.row.minScore) }}
									</div>
								</template>
							</el-table-column>

							<el-table-column
								prop="maxScore"
								label="最大值"
								width="80"
								align="center"
							>
								<template slot-scope="scope">
									<div class="content_div">
										{{ dataHandling(scope.row.maxScore) }}
									</div>
								</template>
							</el-table-column>
							<template v-for="item in columConfig[dimensionInfo.code]">
								<el-table-column
									:key="item.name"
									:label="item.label"
									:prop="item.name"
									width="140"
									align="center"
								>
									<template slot-scope="scope">
										<div
											v-html="scope.row[item.name]"
											v-if="item.attrs.html"
										></div>
										<div v-else>{{ scope.row[item.name] }}</div>
									</template>
								</el-table-column>
							</template>

							<el-table-column
								label="操作"
								align="center"
								fixed="right"
								min-width="100"
							>
								<template slot-scope="scope">
									<el-button
										size="mini"
										@click="handleClick('edit', scope.row)"
										type="primary"
										plain
										>编辑
									</el-button>
									<el-button
										size="mini"
										@click="handleDelete(scope.row)"
										type="danger"
										plain
										>删除
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
		<!--结果设置-->
		<el-dialog
			title="结果设置"
			:visible.sync="dialogVisible"
			width="1080px"
			top="30px"
			:close-on-click-modal="false"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form
					ref="ruleForm"
					:rules="rules"
					:model="params"
					label-width="80px"
				>
					<el-tabs
						type="card"
						v-model="languageCode"
						@tab-click="handleTabClick('question')"
					>
						<el-tab-pane
							v-for="(item, index) in languageList"
							:label="item.name"
							:name="item.code"
							:key="index"
						></el-tab-pane>
					</el-tabs>
					<el-row type="flex">
						<el-col :span="12">
							<el-form-item label="类型">
								<div>{{ dimensionInfo.name }}</div>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="维度">
								<div>{{ datumInfo.name }}</div>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row type="flex">
						<el-col :span="12">
							<el-form-item label="最小值" prop="minScore">
								<el-input
									placeholder="请输入最小值"
									v-model="params.minScore"
									type="number"
									style="width: 262px"
								></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="最大值" prop="maxScore">
								<el-input
									placeholder="请输入最大值"
									v-model="params.maxScore"
									type="number"
									style="width: 262px"
								></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<template v-for="item in formModelConfig[dimensionInfo.code]">
						<el-form-item
							:key="item.name"
							:label="item.label"
							:prop="item.name"
						>
							<component
								v-if="item.show ? innerVisible : true"
								:is="item.el"
								v-model="params[item.name]"
								v-bind="item.attrs"
								:params="params ? params : ''"
							/>
						</el-form-item>
					</template>
				</el-form>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisible = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="handleEdit"
					>提 交</el-button
				>
			</span>
		</el-dialog>

		<!-- 添加维度/基准弹框 -->
		<el-dialog
			:title="'添加/编辑维度'"
			:visible.sync="dialogVisibleTopic"
			width="460px"
			:close-on-click-modal="false"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form
					ref="ruleForm"
					:rules="rules"
					:model="params"
					label-width="80px"
				>
					<el-tabs
						type="card"
						v-model="languageCode"
						@tab-click="handleTabClick('dimension')"
					>
						<el-tab-pane
							v-for="(item, index) in languageList"
							:label="item.name"
							:name="item.code"
							:key="index"
						></el-tab-pane>
					</el-tabs>
					<!-- <el-form-item label="维度" v-if="clickType == 'jz'">
						{{ dimensionInfo.name }}
					</el-form-item> -->
					<el-form-item label="ICON">
						<div class="diplay" style="margin-right: 10px">
							<div class="screenshot">
								<span
									v-for="(imgUrl, index) in srcList"
									:key="index"
									class="slideshow"
									v-if="params.icon"
								>
									<el-image
										style="width: 75px; height: 75px; border-radius: 6px"
										:src="imgUrl"
										fit="cover"
										@click="getPolicy"
									/>
								</span>
								<div
									class="up-btn"
									style="width: 75px; height: 75px; line-height: 80px"
									@click="getPolicy"
									v-if="!params.icon"
								>
									<i class="el-icon-plus"></i>
								</div>
							</div>
							<input
								type="file"
								ref="file"
								@change="getFile"
								accept="image/png,image/jpg"
							/>
						</div>
					</el-form-item>

					<el-form-item label="名称" prop="name">
						<el-input placeholder="请填写名称" v-model="params.name"></el-input>
					</el-form-item>

					<el-form-item prop="code" label="标识">
						<el-input placeholder="请填写标识" v-model="params.code"></el-input>
					</el-form-item>

					<el-form-item
						label="计分方式"
						prop="scoreType"
						v-if="clickType == 'jz'"
					>
						<el-radio v-model="params.scoreType" :label="0">计入总分</el-radio>
						<el-radio v-model="params.scoreType" :label="1">平均分</el-radio>
					</el-form-item>
					<el-form-item label="说明" prop="descr">
						<el-input
							type="textarea"
							:autosize="{ minRows: 2, maxRows: 4 }"
							placeholder="请输入说明"
							v-model="params.descr"
						>
						</el-input>
					</el-form-item>
					<el-form-item prop="seq" label="序号">
						<el-input placeholder="请填写序号" v-model="params.seq"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisibleTopic = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="lwhandleEdit"
					>提 交</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { emptyShow, isEmpty } from "@utils/tools";
import richText from "@comp/richText";
import { getEditFormConfig, getColumnConfig } from "./tzfgSet.js";

export default {
	name: "mjywlList",
	components: {
		richText,
	},
	data() {
		return {
			columConfig: getColumnConfig(),
			formModelConfig: getEditFormConfig(),
			dimensionInfoList: [],
			emptyShow,
			isEmpty,
			detalisObj: {},
			dimensionList: [],
			params: {},
			srcList: [],
			isMoer: true,
			dimensionInfoId: "",
			dimensionInfo: {},
			datumList: [],
			datumId: "",
			datumInfo: {},
			loading: false,
			resulData: [],
			innerVisible: false,
			dialogVisible: false,
			rules: {
				minScore: [
					{
						required: true,
						message: "请输入最小值",
						trigger: "blur",
					},
				],
				maxScore: [
					{
						required: true,
						message: "请输入最大值",
						trigger: "blur",
					},
				],
			},
			languageList: [],
			languageCode: "",
			examResultId: "",
		};
	},
	watch: {
		dialogVisible() {
			if (this.dialogVisible == false) {
				this.$refs.ruleForm.resetFields();
				this.params = {};
				this.innerVisible = false;
			}
		},
	},
	mounted() {
		this.getAppraisalData();
		this.getLanguageList();
	},
	methods: {
		//获取语言列表
		async getLanguageList() {
			this.loading = true;
			//角色列表
			const { data: res } = await this.$post(`/language/list`, {
				adminStatus: 1,
			});
			this.loading = false;
			this.languageList = res.data;
			this.languageCode = res.data[0].code;
		},
		handleTabClick(e) {
			if (e == "question" && this.examResultId) {
				this.getDetail();
			}
		},
		async getDetail() {
			this.innerVisible = false;
			const { data: resData } = await this.$get(
				`exam/result/info/${this.examResultId}`,
				{
					headers: {
						isLoading: true,
						"Language-Code": this.languageCode,
					},
				}
			);
			if (resData.result != 200) return;
			resData.data.minScore = resData.data.minScore / 100;
			resData.data.maxScore = resData.data.maxScore / 100;
			this.params = resData.data;
			this.innerVisible = true;
		},
		/**
		 * 获取测评详情
		 */
		async getAppraisalData() {
			this.loading = true;
			const { data: resData } = await this.$get(
				`exam/info/${this.$route.query.examId}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.detalisObj = resData.data;
			this.getDimensionList();
		},
		/**
		 * 获取基准列表
		 */
		async getJZList() {
			this.datumList = [];
			this.loading = true;

			this.loading = false;
			this.datumList = this.dimensionInfoList.filter(
				(item) => this.dimensionInfoId == item.parentId
			);
			this.datumId = this.datumList[0].code;
			this.datumInfo = this.datumList[0];
			this.getWdResultList();
		},
		/**
		 * 获取测评维度列表
		 */
		async getDimensionList() {
			this.dimensionList = [];
			this.loading = true;
			const { data: resData } = await this.$get(`exam/dimension/list`, {
				params: {
					examId: this.$route.query.examId,
				},
			});
			this.loading = false;
			if (resData.result != 200) return;
			if (resData.data) {
				this.dimensionInfoList = resData.data;
				this.dimensionList = resData.data.filter((item) => item.parentId == 0);
				this.dimensionInfoId = resData.data[0].examDimensionId;
				this.dimensionInfo = resData.data[0];
				this.getJZList();
			}
		},
		/**
		 * 维度切换
		 */
		activeEvent(item, e) {
			if (e == "wd") {
				this.dimensionInfoId = item.examDimensionId;
				this.dimensionInfo = item;
				this.getJZList();
			} else {
				this.datumId = item.code;
				this.datumInfo = item;
				this.getWdResultList();
			}
		},
		/**
		 * 结果编辑
		 */
		async handleClick(type, row = {}) {
			this.clickType = type;
			this.params = {};
			this.dialogVisible = true;
			this.innerVisible = false;
			if (type == "add") {
				this.params = {};
				this.innerVisible = true;
			}
			if (type == "edit") {
				this.examResultId = row.examResultId;
				const { data: resData } = await this.$get(
					`exam/result/info/${row.examResultId}`,
					{
						headers: {
							isLoading: true,
							"Language-Code": this.languageCode,
						},
					}
				);
				if (resData.result != 200) return;
				resData.data.minScore = resData.data.minScore / 100;
				resData.data.maxScore = resData.data.maxScore / 100;
				this.params = resData.data;
				this.innerVisible = true;
			}
		},
		/**
		 * 处理数据为小数
		 */
		dataHandling(data) {
			return data / 100;
		},
		/**
		 * 删除结果
		 */
		handleDelete(row) {
			this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$delete(
					`exam/result/info/${row.examResultId}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.$message.success("删除成功!");
				this.getWdResultList();
			});
		},
		/**
		 * 获取测评维度结果列表
		 */
		async getWdResultList() {
			this.loading = true;
			let temp = {
				examId: this.$route.query.examId,
				examDimensionCode: this.datumInfo.code,
			};
			const { data: resData } = await this.$get(`exam/result/list`, {
				params: temp,
			});
			this.loading = false;
			if (resData.result != 200) return;
			if (resData.data) {
				this.resulData = resData.data;
			} else {
				this.resulData = [];
			}
		},
		/**
		 * 保存设置结果
		 */
		handleEdit() {
			if (
				parseInt(this.params.minScore * 100) >
				parseInt(this.params.maxScore * 100)
			) {
				this.$message.error("最小值不能大于最大值");
				return;
			}
			this.$refs.ruleForm.validate((valid) => {
				if (!valid) return;
				this.$confirm("确认保存数据, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					if (this.clickType == "add") {
						this.params.examDimensionCode = this.datumInfo.code;

						this.params.minScore = this.params.minScore * 100;
						this.params.maxScore = this.params.maxScore * 100;
						this.params.examId = this.$route.query.examId;
						const { data: resData } = await this.$post(
							"exam/result/info",
							this.params,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						this.getWdResultList();
						this.examResultId = resData.data;
						this.dialogVisible = false;
						this.$message.success("添加成功!");
						this.params = {};
					} else {
						this.params.minScore = this.params.minScore * 100;
						this.params.maxScore = this.params.maxScore * 100;
						const { data: resData } = await this.$put(
							"exam/result/info",
							this.params,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						this.getWdResultList();
						// this.dialogVisible = false;
						this.$message.success("修改成功!");
					}
				});
			});
		},
		/**
		 * 维度/基准数据保存
		 */
		lwhandleEdit() {
			this.$refs.ruleForm.validate((valid) => {
				if (!valid) return;
				this.$confirm("确认保存数据, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					this.params.examId = this.$route.query.examId;
					const { data: resData } = await this.$post(
						"exam/dimension/info",
						this.params,
						{
							headers: {
								isLoading: true,
								"Language-Code": this.languageCode,
							},
						}
					);
					if (resData.result != 200) return;
					this.$message.success("操作成功!");
					this.handleDimensionEdit(this.clickType);
					this.params = {};
					this.srcList = [];
					// this.dialogVisibleTopic = false;
				});
			});
		},
		/**
		 * 编辑维度/基准
		 */
		async handleDimensionEdit(e) {
			this.clickType = e;
			if (e == "wd") {
				this.loading = true;
				const { data: resData } = await this.$get(
					`exam/dimension/info/${this.$route.query.examId}/${this.dimensionInfo.code}`,
					{
						headers: {
							"Language-Code": this.languageCode,
						},
					}
				);
				this.loading = false;
				if (resData.result != 200) return;
				this.params = resData.data;
				this.srcList = [];
				if (resData.data.icon) {
					this.params.icon = resData.data.icon;
					this.srcList.push(resData.data.icon);
				}
				this.dialogVisibleTopic = true;
			} else if (e == "jz") {
				this.loading = true;
				const { data: resData } = await this.$get(
					`exam/dimension/info/${this.$route.query.examId}/${this.datumInfo.code}`,
					{
						headers: {
							"Language-Code": this.languageCode,
						},
					}
				);
				this.loading = false;
				if (resData.result != 200) return;
				this.params = resData.data;
				this.srcList = [];
				if (resData.data.icon) {
					this.params.icon = resData.data.icon;
					this.srcList.push(resData.data.icon);
				}
				this.dialogVisibleTopic = true;
			}
		},
		handelResultSet() {
			this.$router.push({
				name: "TZFG_RG_SET",
				query: {
					examId: this.$route.query.examId,
				},
			});
		},
		goBack() {
			this.$router.back();
		},
		//过滤标签数据
		setHtmlData(str) {
			let obj = "";
			if (str) {
				obj = str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "");
			}
			return obj;
		},
	},
};
</script>

<style scoped lang="scss">
.appraisal-center {
	width: 90%;
	margin: 0 auto;
}

.fonts {
	font-size: 14px;
}

.topic-outer {
	width: 100%;
	background: #fff;
	overflow: hidden;
	margin-top: 20px;
	padding-bottom: 30px;
}

.flex-box {
	display: -webkit-box;
	display: -moz-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
}

.fl1 {
	flex: 1;
	-webkit-flex: 1;
}

.glay {
	color: #8492a6;

	i {
		font-style: normal;
		color: #f56c6c;
	}
}

.pub-line {
	margin-top: 30px;
}

.marr {
	margin-top: 20px;
}

.tag-marr {
	margin-right: 5px;
	cursor: pointer;
}

.activeBg {
	background: #b3d8ff;
	color: #fff;
}

.activeBg1 {
	background: #fbc4c4;
	color: #fff;
}

.public-dialog-form {
	height: 72vh;
	overflow-y: scroll;
}
</style>
